
import React from "react";
import { Box, Card, CardContent, Typography, Divider } from "@mui/material";
import { iconos } from "../../../data";




export const TarjetaResumenInfo = ({ data, color, titulo }) => {


    // const theme = useTheme();

    return (
        <Card sx={{ mt:1, mb:4, borderRadius:2, position: "relative", overflow:"visible"}}>
            <CardContent sx={{ pt:1, pb:0 }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb:1 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box sx={{ backgroundColor: color, borderRadius:"50%", p:1, mr:1, display:"flex"}}>
                            {React.cloneElement(iconos['documento'], {style:{fontSize:15, color:'white'} })}
                        </Box>
                        <Typography variant="subtitle1" component="h2" sx={{fontWeight:600, fontSize:15, color:color}}>
                            { titulo }
                        </Typography>
                    </Box>
                </Box>
                
                <Divider sx={{ mb:1 }} />
                
                <Box sx={{display:"flex", flexDirection:{xs: "column", sm: "row"},
                    justifyContent:"space-between", alignItems:{xs:"flex-start", sm:"center"},
                }}>
                    <Box sx={{width: {xs:"100%", sm:"30%", textAlign:'center'} }}>
                        <Typography variant="body2" sx={{fontWeight:600, fontSize:14}}>
                            Nº REGISTROS
                        </Typography>
                        <Typography variant="h2" sx={{fontWeight:700}}>
                            {data.registros || 0}
                        </Typography>
                    </Box>

                    <Box sx={{flex:1}} />
                
                    <Box sx={{p:1, borderRadius:2, width:{xs:"100%", sm:"20%"}, backgroundColor:color, textAlign:'center'}}>
                        <Typography variant="body2" sx={{ color:"white", fontWeight: 600, fontSize:14 }}>
                            CANTIDAD
                        </Typography>
                        <Typography variant="h2" sx={{fontWeight:700, color:'white' }}>
                            {data.total}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>

    );
};



